import React from 'react'
import {
  WelcomePage,
  BrideGroom,
  EventDetails,
  CountdownTimer,
  WeddingSurvey,
  DressCode,
  GiftPreference,
  Gifts
} from '../../composites'

const WeddingInvitation = () => {
  return (
    <div>
      <WelcomePage />
      <BrideGroom />
      {/* <TimelineContent /> */}
      <EventDetails />
      <DressCode />
      <Gifts />
      <WeddingSurvey />
      <GiftPreference />
      <CountdownTimer />
      {/* <HealthProtocols />
      <PictureGallery />
      <ClosingPage />
      <Footer /> */}
    </div>
  )
}

export default WeddingInvitation
